module.exports = __webpack_public_path__ + "static/media/Prem.b29d79a6.svg";